// extracted by mini-css-extract-plugin
export default {"searchedTitle":"styles_searchedTitle__SOgaV"};